import logo from "./logo.png";

import { cn } from "@/shared/lib/cn";

const PLATE = "bg-[#121721]";

/** The geometric 4: the left of the wordmark file, cropped to a square. */
export function LogoMark({ className }: { className?: string }) {
  return (
    <span
      className={cn(
        "relative inline-block size-8 shrink-0 overflow-hidden rounded-xl",
        PLATE,
        className,
      )}
    >
      <img
        src={logo}
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 size-full object-cover object-left p-1"
      />
    </span>
  );
}

/** The website wordmark file, as-is. */
export function LogoWordmark({
  className,
  imgClassName,
}: {
  className?: string;
  imgClassName?: string;
}) {
  return (
    <span
      className={cn("inline-flex shrink-0 items-center rounded-xl px-2.5 py-1.5", PLATE, className)}
    >
      <img src={logo} alt="404 Creative" className={cn("h-7 w-auto", imgClassName)} />
    </span>
  );
}

/** Wordmark plus product name. The name is always left to right ("404 OS", never "OS 404"). */
export function Logo({ className }: { className?: string }) {
  return (
    <span
      dir="ltr"
      className={cn("inline-flex shrink-0 items-center gap-2 whitespace-nowrap", className)}
    >
      <LogoWordmark />
      <span className="text-[15px] font-semibold tracking-[-0.01em] text-ink">
        404 <span className="text-brand">OS</span>
      </span>
    </span>
  );
}
